export enum FactorsAffectingCareConstants {
  SET_DISPATCH_FACTORS = 'factorsAffectingCare/SET_DISPATCH_FACTORS',
  SET_DISPATCH_FACTORS_PNNV = 'factorsAffectingCare/SET_DISPATCH_FACTORS_PNNV',
  SET_RESPONSE_FACTORS = 'factorsAffectingCare/SET_RESPONSE_FACTORS',
  SET_RESPONSE_FACTORS_PNNV = 'factorsAffectingCare/SET_RESPONSE_FACTORS_PNNV',
  SET_SCENE_FACTORS = 'factorsAffectingCare/SET_SCENE_FACTORS',
  SET_SCENE_FACTORS_PNNV = 'factorsAffectingCare/SET_SCENE_FACTORS_PNNV',
  SET_TRANSPORT_FACTORS = 'factorsAffectingCare/SET_TRANSPORT_FACTORS',
  SET_TRANSPORT_FACTORS_PNNV = 'factorsAffectingCare/SET_TRANSPORT_FACTORS_PNNV',
  SET_TURN_AROUND_FACTORS = 'factorsAffectingCare/SET_TURN_AROUND_FACTORS',
  SET_TURN_AROUND_FACTORS_PNNV = 'factorsAffectingCare/SET_TURN_AROUND_FACTORS_PNNV',
  SET_FACTORS = 'factorsAffectingCare/SET_FACTORS',
  SET_FACTORS_AFFECTING_CARE_STATE = 'factorsAffectingCare/SET_FACTORS_AFFECTING_CARE_STATE',
  RESET_FACTORS_AFFECTING_CARE_STATE = 'factorsAffectingCare/RESET_FACTORS_AFFECTING_CARE_STATE',
  SAVE_FACTORS_AFFECTING_CARE_STATE = 'factorsAffectingCare/SAVE_FACTORS_AFFECTING_CARE_STATE',
  SET_SHOW_FACTORS = 'factorsAffectingCare/SET_SHOW_FACTORS',
  SET_SHOW_RESPONSE_SCENE_TRANSPORT_FACTORS = 'factorsAffectingCare/SET_SHOW_RESPONSE_SCENE_TRANSPORT_FACTORS',
  SET_SHOW_DISPATCH_FACTORS = 'factorsAffectingCare/SET_SHOW_DISPATCH_FACTORS',
  SET_SHOW_TURN_AROUND_FACTORS = 'factorsAffectingCare/SET_SHOW_TURN_AROUND_FACTORS',
  GET_FACTORS_AFFECTING_CARE_STATE = 'factorsAffectingCare/GET_FACTORS_AFFECTING_CARE_STATE',
}
